import { Instagram } from "lucide-react";
import Logo from "@/components/Logo";
import { FOOTER } from "@/constants/testIds";
import { BRAND, PAYHIP_STORE_URL } from "@/lib/config";

const cols = [
  {
    label: "Explore",
    links: [
      { name: "About", href: "#about" },
      { name: "Pillars", href: "#pillars" },
      { name: "Collection", href: "#collection" },
      { name: "Journal", href: "#journal" },
      { name: "Playlist", href: "#playlist" },
    ],
  },
  {
    label: "Shop",
    links: [
      { name: "Storefront", href: PAYHIP_STORE_URL, external: true },
      { name: "Apparel", href: PAYHIP_STORE_URL, external: true },
      { name: "Digital", href: PAYHIP_STORE_URL, external: true },
      { name: "Accessories", href: PAYHIP_STORE_URL, external: true },
    ],
  },
  {
    label: "Company",
    links: [
      { name: "Contact", href: "#contact" },
      { name: "Community", href: "#community" },
      { name: "Newsletter", href: "#newsletter" },
    ],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();

  const handleAnchor = (href) => (e) => {
    if (href.startsWith("#")) {
      e.preventDefault();
      const el = document.getElementById(href.slice(1));
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer
      data-testid={FOOTER.root}
      className="relative text-[#e8ecef] pt-28 pb-12 border-t border-[#1a2028]"
      style={{ backgroundColor: "#050505" }}
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        {/* Closing statement */}
        <div className="max-w-4xl">
          <p className="text-[10px] tracking-[0.42em] uppercase text-[#8a9498]/70 mb-8">
            A closing note
          </p>
          <p className="font-serif text-3xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#e8ecef]">
            Wherever you are in life,<br />
            keep moving with intention.<br />
            <span className="font-light text-[#8a9498]">
              Live With Vision.
            </span>
          </p>
        </div>

        {/* Grid */}
        <div className="mt-24 md:mt-32 grid grid-cols-2 md:grid-cols-5 gap-12">
          <div className="col-span-2">
            <Logo className="h-10 w-40" color="#e8ecef" />
            <p className="mt-8 text-[#8a9498] text-sm leading-relaxed max-w-xs font-light">
              A lifestyle movement. Made for people who choose growth, presence,
              and purpose.
            </p>
            <a
              href={BRAND.instagramUrl}
              target="_blank"
              rel="noreferrer noopener"
              className="mt-8 inline-flex items-center gap-2 text-[#8a9498] hover:text-[#e8ecef] text-[11px] tracking-[0.3em] uppercase transition-colors duration-500"
            >
              <Instagram size={14} /> {BRAND.instagramHandle}
            </a>
          </div>

          {cols.map((col) => (
            <div key={col.label}>
              <p className="text-[10px] tracking-[0.32em] uppercase text-[#8a9498]/70 mb-8">
                {col.label}
              </p>
              <ul className="space-y-4">
                {col.links.map((l) => (
                  <li key={l.name}>
                    <a
                      href={l.href}
                      target={l.external ? "_blank" : undefined}
                      rel={l.external ? "noreferrer noopener" : undefined}
                      onClick={
                        l.external ? undefined : handleAnchor(l.href)
                      }
                      className="text-sm text-[#e8ecef]/80 hover:text-[#e8ecef] transition-colors duration-300 font-light"
                    >
                      {l.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="mt-20 pt-8 border-t border-[#1a2028] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-[11px] tracking-[0.28em] uppercase text-[#8a9498]/70">
            © {year} VISION. All rights reserved.
          </p>
          <div className="flex items-center gap-8 text-[11px] tracking-[0.28em] uppercase text-[#8a9498]/70">
            <a href="#" className="hover:text-[#e8ecef] transition-colors">
              Privacy
            </a>
            <a href="#" className="hover:text-[#e8ecef] transition-colors">
              Terms
            </a>
            <a
              href="#contact"
              onClick={handleAnchor("#contact")}
              className="hover:text-[#e8ecef] transition-colors"
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
